import { Component } from "@angular/core";

@Component({
	selector: "app-trainings",
	templateUrl: "./trainings.component.html",
	styleUrls: ["./trainings.component.scss"],
	standalone: false
})
export class TrainingsComponent {}
